import Vue from "vue";
import VueRouter from "vue-router";
import App from "./App.vue";
import store from "./store";

import configEnv from "./configEnv";

// Páginas
import NotFound from "./components/NotFound.vue"; //404
import Login from "./components/Login.vue";
import Homepage from "./Pages/Homepage.vue";
import ProductsList from "./Pages/Store/ProductsList.vue";
import Customization from "./Pages/Store/Customization.vue";
import ProductDetails from "./components/ProductDetails.vue";
import Register from "./components/Register.vue";
import RegisterSimple from "./components/RegisterSimple.vue";
import GerarContrato from "./components/GerarContrato.vue";
import RecuperarSenha from "./components/RecuperarSenha.vue";
import CrazyExtrato from "./components/CrazyExtrato.vue";
import CrazyRescue from "./components/CrazyRescue.vue";
import CrazyRescueDetail from "./components/CrazyRescueDetail.vue";
import CrazyRegulament from "./components/CrazyRegulament.vue";
import CrazyHotSite from "./components/CrazyHotSite.vue";
import CrazyHotSitePage from "./components/CrazyHotSitePage.vue";
import CrazySurprise from "./components/CrazySurprise.vue";
import CrazyCategory from "./components/CrazyCategory.vue";

import DownloadDanfe from "./components/DownloadDanfe.vue";
import CadastroVendaDireta from "./components/CadastroVendaDireta.vue";
import DirectSaleCommission from "./components/DirectSaleCommission.vue";
import MyOrders from "./components/MyOrders.vue";
import OrderDetail from "./components/OrderDetail.vue";
import MyAccount from "./components/MyAccount.vue";
// import LandingPage from './components/LandingPage.vue'
import TermsOfUse from "./components/termsOfUse.vue";
import ServiceTerm from "./components/ServiceTerm.vue";
import ContactUs from "./components/ContactUs.vue";
import MyKombiCart from "./components/MyKombiCart.vue";
import MyKombiDirectSaleCart from "./components/MyKombiDirectSaleCart.vue";
import SelectShipping from "./components/SelectShipping.vue";
import SelectShippingDirectSale from "./components/SelectShippingDirectSale.vue";
import ExpressQuotation from "./components/ExpressQuotation.vue";
import RMA from "./components/RMA.vue";
import TransferenciaSaldo from "./Pages/ContaCorrente/TransferenciaSaldo.vue";
import ConsultarTransferenciaSaldo from "./Pages/ContaCorrente/ConsultarTransferenciaSaldo";
import Deposito from "./Pages/ContaCorrente/Deposito.vue";
import ConsultarComprovanteDeposito from "./Pages/ContaCorrente/ConsultarComprovanteDeposito";
import Estorno from "./Pages/ContaCorrente/Estorno.vue";
import ConsultarEstorno from "./Pages/ContaCorrente/ConsultarEstorno";
import ImportacaoProduto from "./components/ImportacaoProduto.vue";
import CampanhaToscana from "./components/CampanhaToscana.vue";
import PortalCrazyCard from "./components/partials/my-account/PortalCrazyCard.vue";
import DashResaler from "./Pages/Dashboard/DashResaler.vue";
import DashManagement from "./Pages/Dashboard/DashManagement.vue";

import CommercialConditions from "./components/CommercialConditions.vue";
import PoliceOfSecurity from "./components/PoliceOfSecurity.vue";
import PoliceIntegrateManager from "./components/PoliceIntegrateManager.vue";
import LicenceGNL from "./components/LicenceGNL.vue";
import AboutUs from "./components/AboutUs.vue";
import TicketPaymentList from "./components/FinancialTicketPaymentList.vue";
import TicketPayment from "./components/FinancialTicketPayment.vue";
import TicketPaymentCash from "./components/FinancialTicketPaymentCash.vue";
import Financial2WayTicket from "./components/Financial2WayTicket.vue";
import SearchList from "./components/SearchList.vue";
import ClosedKombi from "./components/ClosedKombi.vue";
import RDStationCallback from "./components/RDStationCallback.vue";
import RDStationIntegracao from "./components/RDStationIntegracao.vue";
import CSATResposta from "./components/CSATResposta.vue";

import OrderPayment from "./components/order-payment/OrderPayment.vue";

import Transparencia from "./components/Transparencia.vue";
import PrivacyPolicy from "./components/PrivacyPolicy.vue";

// Partials
import Loader from "./components/partials/Loader.vue";
import { Datetime } from "vue-datetime";
import VuejsDialog from "vuejs-dialog";
import { Settings } from "luxon";
import "vue-datetime/dist/vue-datetime.css";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import VueTagManager from "vue-tag-manager";

Settings.defaultLocale = "pt-br";

Vue.component("datetime", Datetime);

Vue.use(VuejsDialog);
Vue.config.debug = true;
Vue.config.devtools = true;
Vue.config.productionTip = false;
Vue.config.silent = false;
// Dependências
import VueFullscreen from 'vue-fullscreen';
import VueTheMask from "vue-the-mask";
import vSelect from "vue-select";
import swal from "sweetalert";
import VueBarCode from "vue-barcode";
import vMoney from "v-money";
import Vuetify from "vuetify";
import Vue2Filters from "vue2-filters";
import VueMeta from "vue-meta";

// Estilos de Dependências
import "vue-select/dist/vue-select.css";
import Project from "./components/solar-calculator/Project";
import EditProject from "./components/solar-calculator/EditProject";
import Projects from "./components/solar-calculator/Projects";
import TemplatePdfProject from "./components/solar-calculator/template/TemplatePdfProject";
import TemplatePdfProjectNewV1 from "./components/solar-calculator/template/TemplatePdfProjectNewV1";
import MonitoringError from './services/MonitoringError'

Vue.component("vue-select", vSelect);
Vue.component("barcode", VueBarCode);
Vue.component("Loader", Loader);

Vue.use(VueFullscreen);
Vue.use(VueTheMask);
Vue.use(Vuetify);
Vue.use(Vue2Filters);
Vue.use(VueMeta);

Vue.use(VueRouter);
Vue.use(vMoney);
Vue.use({
    install(Vue) {
        Vue.swal = swal;
        Vue.prototype.$swal = swal;
    },
});

Vue.use(VueTagManager, {
    gtmId: "GTM-WWDS4WB",
});

// Variáveis Globais
Vue.prototype.$product = function ({
    id,
    code,
    name,
    state,
    img,
    description,
    url,
    price,
    promotionalPrice,
    showActions = false,
    attributes,
    information = "",
} = {}) {
    this.id = id;
    this.code = code;
    this.name = name;
    this.state = state;
    this.img = img;
    this.description = description;
    this.url = url;
    this.price = price;
    this.promotionalPrice = promotionalPrice;
    this.showActions = showActions;
    this.attributes = attributes;
    this.information = information || "";
};

Vue.prototype.$useHeader = true;

Vue.prototype.$formInput = function (required, value) {
    // Define um padrão para estrutura de cada input do formulário
    this.required = required !== undefined ? required : true;
    this.value = value !== undefined ? value : "";

    this.validation = {
        // Status verifica se o input é obrigatório e possui valor, e retorna verdadeiro ou falso
        // Para que o usuário seja barrado em caso de um submit sem dados
        status: !(this.required && this.value === ""),
        message: this.required ? "Por favor, preencha o campo acima" : "",
    };
};

const env = process.env.VUE_APP_ENV
if(env !== 'production')
    console.log('ENVS:', env, configEnv[env])

Vue.prototype.$apiUrl = configEnv[env].apiUrl
Vue.prototype.$apiUrlAPI = configEnv[env].apiUrlAPI
Vue.prototype.$SiteUrl = configEnv[env].siteUrl
Vue.prototype.$baseUrl = configEnv[env].baseUrl
Vue.prototype.$mktUrl = configEnv[env].mktUrl
Vue.prototype.$imageUrl = configEnv[env].imageUrl

Vue.prototype.$rotaCalculadora = "/calculadora-aldo-solar/projetos";

Vue.config.errorHandler = (err, vm, info) => {
    // err: error trace
    // vm: component in which error occured
    // info: Vue specific error information such as lifecycle hooks, events etc.

    // TODO: Perform any custom logic or log to server
    if(err.status === 401) return

    MonitoringError.SendError(configEnv[env].apiUrl, err, vm, info)
};

Vue.config.warnHandler = (err, vm, info) => {
    // err: error trace
    // vm: component in which error occured
    // info: Vue specific error information such as lifecycle hooks, events etc.

    // TODO: Perform any custom logic or log to server
    MonitoringError.SendError(configEnv[env].apiUrl, err, vm, info)
};

// Rotas da aplicação
const routes = [
    {
        path: "/loja",
        component: Homepage,
        meta: {
            title: "Aldo Componentes",
            metaTags: [
                {
                    name: "description", // Nome/tipo da metatag
                    content:
                        "Fabricante e Distribuidora Oficial exclusivamente para revendedor, integrador e instalador TI, Energia Solar e Drone.  Entrega rápida e segura. Cadastre-se e comece a vender.", // Conteúdo da metatag
                },
            ],
        },
    },
    {
        // path: '/loja/produtos/:menu/:name?/:sub1?/:sub2?/:sub3?/:sub4?',
        path: "/loja/busca/:name?(/[-a-z0-9]+)*",
        component: ProductsList,
        name: "ListProductsBusca",
    },
    {
        // path: '/loja/produtos/:menu/:name?/:sub1?/:sub2?/:sub3?/:sub4?',
        path: "/loja/categoria/:name?(/[-a-z0-9]+)*",
        component: ProductsList,
        name: "ListProductsCategoria",
    },
    {
        // path: '/loja/produtos/:menu/:name?/:sub1?/:sub2?/:sub3?/:sub4?',
        path: "/loja/catalogo-produtos/:name?(/[-a-z0-9]+)*",
        component: ProductsList,
        name: "ListProductsCategoria-Catalogo",
    },
    {
        // path: '/loja/produtos/:menu/:name?/:sub1?/:sub2?/:sub3?/:sub4?',
        path: "/loja/campanha/:name?(/[-a-z0-9]+)*",
        component: ProductsList,
        name: "ListProductsCampanha",
    },
    {
        // path: '/loja/produtos/:menu/:name?/:sub1?/:sub2?/:sub3?/:sub4?',
        path: "/loja/marca/:name?(/[-a-z0-9]+)*",
        component: ProductsList,
        name: "ListProductsMarca",
    },
    {
        // path: '/loja/produtos/:menu/:name?/:sub1?/:sub2?/:sub3?/:sub4?',
        path: "/loja/home/:name?(/[-a-z0-9]+)*",
        component: ProductsList,
        name: "ListProductsMarca-Home",
        meta: {
            title: "Categoria Exemplo",
        },
    },
    {
        path: "/loja/personalizacao-gerador",
        component: Customization,
    },
    {
        path: "/loja/produto/:code/:name",
        component: ProductDetails,
    },
    {
        path: "/login",
        alias: "/cadastro",
        component: Login,
        meta: {
            title: "Acessar",
        },
    },
    {
        path: "/cadastro/:cnpj",
        component: Register,
        meta: {
            title: "Cadastrar",
        },
    },
    {
        path: "/cadastro-simplificado/:cnpj",
        component: RegisterSimple,
        meta: {
            title: "Cadastrar",
        },
    },
    {
        path: "/loja/gerarcontrato",
        component: GerarContrato,
        meta: {
            title: "Gerar Contrato",
        },
    },
    {
        path: "/recuperar-senha/:id?/:token?",
        component: RecuperarSenha,
        meta: {
            title: "Recuperar Senha",
        },
    },
    {
        path: "/primeiro-acesso/:id?/:token?",
        component: RecuperarSenha,
        meta: {
            title: "Primeiro Acesso",
        },
    },

    {
        path: "/loja/minha-conta/download-danfe",
        component: DownloadDanfe,
        meta: {
            title: "Download Danfe",
        },
    },
    {
        path: "/loja/crazy-card/extrato",
        component: CrazyExtrato,
        meta: {
            title: "Crazy Extrato",
        },
    },
    {
        path: "/loja/crazy-card/resgate",
        component: CrazyRescue,
        meta: {
            title: "Crazy - Resgate de Benefícios",
        },
    },
    {
        path: "/loja/crazy-card/resgate/detalhe/:id",
        component: CrazyRescueDetail,
        name: "crazy-rescue-detail",
        meta: {
            title: "Crazy - Resgate de Benefícios - Detalhe",
        },
    },
    {
        path: "/loja/crazy-card/regulamento",
        component: CrazyRegulament,
        meta: {
            title: "Crazy - Regulamento",
        },
    },
    {
        // path: '/loja/produtos/:menu/:name?/:sub1?/:sub2?/:sub3?/:sub4?',
        path: "/loja/selecionados/:name?(/[-a-z0-9]+)*",
        component: ProductsList,
        name: "ListProductsCategoria-Selecionados",
    },
    {
        path: "/loja/marcas",
        component: CrazyHotSite,
        alias: "/marcas",
        name: "hotsite-marcas",
        meta: {
            title: "Portal",
        },
    },
    {
        path: "/loja/campanhas",
        component: CrazyHotSite,
        alias: "/campanhas",
        name: "hotsite-campanhas",
        meta: {
            title: "Portal",
        },
    },
    {
        path: "/loja/marcas/:id",
        component: CrazyHotSitePage,
        alias: "/marcas/:id",
        name: "hotsite-detalhe-marcas",
        meta: {
            title: "Portal",
        },
    },
    {
        path: "/loja/campanhas/:id",
        alias: "/campanhas/:id",
        component: CrazyHotSitePage,
        name: "hotsite-detalhe-campanhas",
        meta: {
            title: "Portal",
        },
    },
    {
        path: "/loja/crazy-card",
        component: PortalCrazyCard,
        meta: {
            title: "Portal Crazy Card",
        },
    },
    {
        path: "/loja/crazy-card/categoria/:id",
        component: CrazyCategory,
        meta: {
            title: "Crazy Card Categoria",
        },
    },
    {
        path: "/loja/portais/crazy-suprise",
        component: CrazySurprise,
        name: "CrazySurprise",
        meta: {
            title: "Portal",
        },
    },
    {
        path: "/financeiro/comissao-venda-direta",
        component: DirectSaleCommission,
        meta: {
            title: "Comissão Venda Direta",
        },
    },
    {
        path: "/loja/minha-conta/cadastro-venda-direta",
        component: CadastroVendaDireta,
        meta: {
            title: "Cadastro Venda Direta",
        },
    },
    {
        path: "/loja/minha-conta/campanha-partiu-toscana-abb",
        name: "campanha-toscana",
        component: CampanhaToscana,
        meta: {
            title: "Campanha Toscana",
        },
    },
    {
        path: "/loja/minha-conta/meus-pedidos/:tipo",
        name: "meus-pedidos",
        component: MyOrders,
        meta: {
            title: "Meus Pedidos",
        },
    },
    {
        path: "/detalhes-do-pedido/:id/:tipo",
        component: OrderDetail,
        name: "detalhe-pedido",
        meta: {
            title: "Detalhe do Pedido",
        },
    },
    {
        path: "/loja/minha-conta",
        component: MyAccount,
        name: "MinhaConta",
        meta: {
            title: "Minha Conta",
        },
    },
    {
        path: "/financeiro/boleto",
        component: TicketPaymentList,
        name: "Boleto",
        meta: {
            title: "Boletos",
        },
    },
    {
        path: "/financeiro/duplicata/:crc_cupomnf/:crc_serienf/:crr_parcela",
        component: TicketPayment,
        name: "BoletoView",
        meta: {
            title: "Boleto",
        },
    },
    {
        path: "/financeiro/duplicatavista/:numero",
        component: TicketPaymentCash,
        name: "BoletoAVistaView",
        meta: {
            title: "Boleto",
        },
    },
    {
        path: "/financeiro/segundavia",
        component: Financial2WayTicket,
        name: "Financial2WayTicket",
        meta: {
            title: "2° via de Boleto",
        },
    },
    {
        path: "/loja/pesquisa/:search",
        component: SearchList,
        meta: {
            title: "Busca",
        },
    },
    {
        path: "/termos-de-uso",
        component: TermsOfUse,
        name: "TermsOfUse",
        meta: {
            title: "Termos de Uso",
        },
    },
    {
        path: "/termo-de-atendimento",
        component: ServiceTerm,
        name: "ServiceTerm",
        meta: {
            title: "Termo de Atendimento",
        },
    },
    {
        path: "/condicoes-comerciais",
        component: CommercialConditions,
        name: "CommercialConditions",
        meta: {
            title: "Condições Comerciais",
        },
    },
    {
        path: "/politicas-de-seguranca",
        component: PoliceOfSecurity,
        name: "PoliceOfSecurity",
        meta: {
            title: "Politicas de Segurança",
        },
    },
    {
        path: "/politica-integrada-de-gestao",
        component: PoliceIntegrateManager,
        name: "PoliceIntegrateManager",
        meta: {
            title: "Politica Integrada de Gestão",
        },
    },
    {
        path: "/licenciamento-gln",
        component: LicenceGNL,
        name: "LicenceGNL",
        meta: {
            title: "GLN - Número Global de Localização",
        },
    },
    {
        path: "/quem-somos",
        component: AboutUs,
        name: "AboutUs",
        meta: {
            title: "Quem Somos",
        },
    },
    {
        path: "/institucional/faleconosco",
        component: ContactUs,
        meta: {
            title: "Aldo Componentes - Institucional - Fale Conosco",
        },
    },
    {
        path: "/loja/meu-carrinho/:tipo",
        component: MyKombiCart,
        meta: {
            title: "Meu Carrinho",
        },
    },
    {
        path: "/loja/meu-carrinho-venda-direta/:tipo",
        component: MyKombiDirectSaleCart,
        meta: {
            title: "Meu Carrinho",
        },
    },
    {
        path: "/transportadora/:tipo",
        component: SelectShipping,
        meta: {
            title: "Selecionar Transportadora",
        },
    },
    {
        path: "/transportadora-venda-direta/:tipo",
        component: SelectShippingDirectSale,
        meta: {
            title: "Selecionar Transportadora",
        },
    },
    {
        path: "/loja/minha-conta/rma",
        component: RMA,
        meta: {
            title: "RMA Online",
        },
    },
    {
        path: "/loja/minha-conta/importacao-produto",
        component: ImportacaoProduto,
        meta: {
            title: "Importação de Produtos",
        },
    },
    {
        path: "/loja/minha-conta/cotacaoexpress",
        component: ExpressQuotation,
        meta: {
            title: "Cotação Express",
        },
    },
    {
        path: `/calculadora-aldo-solar/novo`,
        component: Project,
        meta: {
            title: "Novo Projeto",
        },
    },
    {
        path: `/calculadora-aldo-solar/editar/:id`,
        component: EditProject,
        meta: {
            title: "Editar Projeto",
        },
    },
    {
        path: "/calculadora-aldo-solar/projetos",
        component: Projects,
        meta: {
            title: "Lista de projetos da Calculadora Solar",
        },
    },
    {
        path: "/calculadora-aldo-solar/revenda/dashboard",
        component: DashResaler,
        meta: {
            title: "Dashboard de projetos da Calculadora Solar",
        },
    },
    // {
    //   path :'/calculadora-solar/gestao/sample',
    //   component: DashSample,
    //   meta: {
    //     title: 'Dashboard de projetos da Calculadora Solar'
    //   }
    // },
    {
        path: "/calculadora-aldo-solar/gestao/dashboard",
        component: DashManagement,
        meta: {
            title: "Dashboard de projetos da Calculadora Solar",
        },
    },
    {
        path: "/calculadora-solar-projetos/:id/planoprojeto",
        component: TemplatePdfProject,
        meta: {
            title: "Plano de projeto",
        },
    },
    {
        path: "/calculadora-solar-projetos/gerar-proposta",
        component: TemplatePdfProjectNewV1,
        name: 'template-proposta',
        meta: {
            title: "Proposta",
        },
    },
    {
        path: "/carrinho-fechado",
        component: ClosedKombi,
        meta: {
            title: "Carrinho fechado com sucesso",
        },
    },
    {
        path: "/rdstation/callback",
        component: RDStationCallback,
        meta: {
            title: "Autenticação RDStation",
        },
    },
    {
        path: "/rdstation/integracao",
        component: RDStationIntegracao,
        meta: {
            title: "Autenticação RDStation",
        },
    },
    // Redirects
    {
        path: "/loja/minha-conta/campanha-partiu-toscana-abb",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja";
        },
    },
    {
        path: "/Centrium Server",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/centrium";
        },
    },
    {
        path: "/COOLERMASTER",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/coolermaster";
        },
    },
    {
        path: "/HP SUPRIMENTOS",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/hp-suprimentos";
        },
    },
    {
        path: "/K2 Systems",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/k2-systems";
        },
    },
    {
        path: "/LITE ON",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/lite-on";
        },
    },
    {
        path: "/Q CELLS",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/q-cells";
        },
    },
    {
        path: "/VICTRON ENERGY",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/victron-energy";
        },
    },
    {
        path: "/aldo-solar-365",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/aldo-solar-365";
        },
    },
    {
        path: "/simuladorsolar",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/calculadora-solar/";
        },
    },
    {
        path: "/calculadora-solar",
        beforeEnter(to, from, next) {
            window.location = "https://calculadorasolar.aldo.com.br/";
        },
    },
    {
        path: "/financiamento-energia-solar",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar";
        },
    },
    {
        path: "/financiamento-energia-solar/banrisul.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/barisul";
        },
    },
    {
        path: "/financiamento-energia-solar/bbrasil.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/bbrasil";
        },
    },
    {
        path: "/financiamento-energia-solar/bndes-finame.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/bndes-finame";
        },
    },
    {
        path: "/financiamento-energia-solar/bradesco.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/bradesco";
        },
    },
    {
        path: "/financiamento-energia-solar/bv.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/bv";
        },
    },
    {
        path: "/financiamento-energia-solar/proger.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/proger";
        },
    },
    {
        path: "/financiamento-energia-solar/santander-pj.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/santander-pj";
        },
    },
    {
        path: "/financiamento-energia-solar/santander.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/santander";
        },
    },
    {
        path: "/financiamento-energia-solar/sicredi-pj.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/sicredi-pj";
        },
    },
    {
        path: "/financiamento-bv",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/portais/financiamento-bv";
        },
    },
    {
        path: "/Portais/Conquistas/LicenciamentoGln/SaibaMais",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/conquistas/licenciamento-gln";
        },
    },
    {
        path: "/Institucional/FaleConosco/",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/institucional/faleconosco";
        },
    },
    {
        path: "/seja-revendedor-aldo/",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja";
        },
    },
    {
        path: "/ABB",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/abb";
        },
    },
    {
        path: "/energymonitor",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja";
        },
    },
    {
        path: "/lucroreal",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja";
        },
    },
    {
        path: "/ACER",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/acer";
        },
    },
    {
        path: "/ADATA",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/adata";
        },
    },
    {
        path: "/aldosolar",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/aldo-solar";
        },
    },
    {
        path: "/AOC",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/aoc";
        },
    },
    {
        path: "/APC",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/apc";
        },
    },
    {
        path: "/ASUSTOR",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/asustor";
        },
    },
    {
        path: "/BELKIN",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/belkin";
        },
    },
    {
        path: "/BYD",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/byd";
        },
    },
    {
        path: "/CANADIAN",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/canadian";
        },
    },
    {
        path: "/CENTRIUM",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/centrium";
        },
    },
    {
        path: "/COOLERMASTER",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/collermaster";
        },
    },
    {
        path: "/CORSAIR",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/corsair";
        },
    },
    {
        path: "/DJI",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/dji";
        },
    },
    {
        path: "/FRONIUS",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/fronius";
        },
    },
    {
        path: "/galax",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/galax";
        },
    },
    {
        path: "/GENIUS",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/genius";
        },
    },
    {
        path: "/GIGABYTE",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/gigabyte";
        },
    },
    {
        path: "/HP",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/hp";
        },
    },
    {
        path: "/HyperX",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/hyperx";
        },
    },
    {
        path: "/INTEL",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/intel";
        },
    },
    {
        path: "/INTELBRAS",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/intelbras";
        },
    },
    {
        path: "/K-MEX",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/k-mex";
        },
    },
    {
        path: "/KabyLake",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/kabylake";
        },
    },
    {
        path: "/KINGSTON",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/kingston";
        },
    },
    {
        path: "/lenovo",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/lenovo";
        },
    },
    {
        path: "/MSI",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/msi";
        },
    },
    {
        path: "/Nexans",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/nexans";
        },
    },
    {
        path: "/NVIDIA",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/nvidia";
        },
    },
    {
        path: "/PHILIPS",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/philips";
        },
    },
    {
        path: "/PNY",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/pny";
        },
    },
    {
        path: "/POSITIVO",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/positivo";
        },
    },
    {
        path: "/REFUSOL",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/refusol";
        },
    },
    {
        path: "/ROMAGNOLE",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/romagnole";
        },
    },
    {
        path: "/SEAGATE",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/seagate";
        },
    },
    {
        path: "/SMA",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/sma";
        },
    },
    {
        path: "/SMS",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/sms";
        },
    },
    {
        path: "/STAUBLI",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/staubli";
        },
    },
    {
        path: "/SUPERMICRO",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/supermicro";
        },
    },
    {
        path: "/THESAN",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/thesan";
        },
    },
    {
        path: "/ultracompactpc",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/ultracompactpc";
        },
    },
    {
        path: "/ULTRATOP",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/ultratop-liva-ze";
        },
    },
    {
        path: "/ultratop-liva-ze",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/ultratop-liva-ze";
        },
    },
    {
        path: "/VAIO",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/vaio";
        },
    },
    {
        path: "/YINGLI",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/yingli";
        },
    },
    {
        path: "/Menu/Categorias/",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja";
        },
    },
    {
        path: "/crazy-off",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/campanhas/crazy-off";
        },
    },
    {
        path: "/ALDO SOLAR",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/aldo-solar";
        },
    },
    {
        path: "/VendasPortalSolar",
        beforeEnter(to, from, next) {
            window.location = "http://portalvendas.aldo.com.br/VendasPortalSolar";
        },
    },
    {
        path: "/Microsoft",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/microsoft";
        },
    },
    {
        path: "/MULTILASER",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/multilaser";
        },
    },
    {
        path: "/Menu/Marcas",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas";
        },
    },
    {
        path: "/BATERIAS MOURA",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/baterias-moura";
        },
    },
    {
        path: "/loja/crazy-card/extrato",
        component: CrazyExtrato,
        meta: {
            title: "Crazy Extrato",
        },
    },
    {
        path: "/loja/crazy-card/resgate",
        component: CrazyRescue,
        meta: {
            title: "Crazy - Resgate de Benefícios",
        },
    },
    {
        path: "/loja/crazy-card/regulamento",
        component: CrazyRegulament,
        meta: {
            title: "Crazy - Regulamento",
        },
    },
    {
        path: "/loja/crazy-card",
        component: PortalCrazyCard,
        meta: {
            title: "Portal Crazy Card",
        },
    },
    {
        path: "/loja/crazy-card/categoria/:id",
        component: CrazyCategory,
        meta: {
            title: "Crazy Card Categoria",
        },
    },
    {
        path: "/financeiro/comissao-venda-direta",
        component: DirectSaleCommission,
        meta: {
            title: "Comissão Venda Direta",
        },
    },
    {
        path: "/loja/minha-conta/cadastro-venda-direta",
        component: CadastroVendaDireta,
        meta: {
            title: "Cadastro Venda Direta",
        },
    },
    {
        path: "/loja/pesquisa/:search",
        component: SearchList,
        meta: {
            title: "Busca",
        },
    },
    {
        path: "/institucional/faleconosco",
        component: ContactUs,
        meta: {
            title: "Aldo Componentes - Institucional - Fale Conosco",
        },
    },
    {
        path: "/loja/meu-carrinho/:tipo",
        component: MyKombiCart,
        meta: {
            title: "Meu Carrinho",
        },
    },
    {
        path: "/loja/meu-carrinho-venda-direta/:tipo",
        component: MyKombiDirectSaleCart,
        meta: {
            title: "Meu Carrinho",
        },
    },
    {
        path: "/transportadora/:tipo",
        component: SelectShipping,
        meta: {
            title: "Selecionar Transportadora",
        },
    },
    {
        path: "/transportadora-venda-direta/:tipo",
        component: SelectShippingDirectSale,
        meta: {
            title: "Selecionar Transportadora",
        },
    },
    {
        path: "/loja/minha-conta/rma",
        component: RMA,
        meta: {
            title: "RMA Online",
        },
    },
    {
        path: "/loja/minha-conta/transferencia-saldo",
        name: "transferencia-saldo",
        component: TransferenciaSaldo,
        meta: {
            title: "Transferencia-Saldo",
        },
    },
    {
        path: "/loja/minha-conta/consultar-transferencia-saldo",
        name: "consultar-transferencia-saldo",
        component: ConsultarTransferenciaSaldo,
        meta: {
            title: "Consultar-Transferencia-Saldo",
        },
    },
    {
        path: "/loja/minha-conta/deposito",
        name: "Deposito",
        component: Deposito,
        meta: {
            title: "Deposito",
        },
    },
    {
        path: "/loja/minha-conta/consultar-comprovante-deposito",
        name: "consultar-comprovante-deposito",
        component: ConsultarComprovanteDeposito,
        meta: {
            title: "Consultar-Comprovante-Deposito",
        },
    },
    {
        path: "/loja/minha-conta/estorno",
        name: "estorno",
        component: Estorno,
        meta: {
            title: "Estorno",
        },
    },
    {
        path: "/loja/minha-conta/consultar-estorno",
        name: "consultar-estorno",
        component: ConsultarEstorno,
        meta: {
            title: "Consultar Estorno",
        },
    },
    {
        path: "/loja/minha-conta/importacao-produto",
        component: ImportacaoProduto,
        meta: {
            title: "Importação de Produtos",
        },
    },
    {
        path: "/loja/minha-conta/cotacaoexpress",
        component: ExpressQuotation,
        meta: {
            title: "Cotação Express",
        },
    },
    {
        path: `/calculadora-aldo-solar/novo`,
        component: Project,
        meta: {
            title: "Novo Projeto",
        },
    },
    {
        path: `/calculadora-aldo-solar/editar/:id`,
        component: EditProject,
        meta: {
            title: "Editar Projeto",
        },
    },
    {
        path: "/calculadora-aldo-solar/projetos",
        component: Projects,
        meta: {
            title: "Lista de projetos da Calculadora Solar",
        },
    },
    {
        path: "/calculadora-aldo-solar/revenda/dashboard",
        component: DashResaler,
        meta: {
            title: "Dashboard de projetos da Calculadora Solar",
        },
    },
    // {
    //   path :'/calculadora-solar/gestao/sample',
    //   component: DashSample,
    //   meta: {
    //     title: 'Dashboard de projetos da Calculadora Solar'
    //   }
    // },
    {
        path: "/calculadora-aldo-solar/gestao/dashboard",
        component: DashManagement,
        meta: {
            title: "Dashboard de projetos da Calculadora Solar",
        },
    },
    {
        path: "/calculadora-solar-projetos/:id/planoprojeto",
        component: TemplatePdfProject,
        meta: {
            title: "Plano de projeto",
        },
    },
    {
        path: "/carrinho-fechado",
        component: ClosedKombi,
        meta: {
            title: "Kombi fechada com sucesso",
        },
    },
    {
        path: "/rdstation/callback",
        component: RDStationCallback,
        meta: {
            title: "Autenticação RDStation",
        },
    },
    {
        path: "/rdstation/integracao",
        component: RDStationIntegracao,
        meta: {
            title: "Autenticação RDStation",
        },
    },
    {
        path: "/csat-venda/:pedido/:score",
        component: CSATResposta,
        name: 'csat-venda',
        meta: {
            title: "CSAT",
        },
    },
    {
        path: "/transparencia",
        component: Transparencia,
        meta: {
            title: "Relatório de Transparência e Igualdade Salarial de Mulheres e Homens",
        },
    },
    {
        path: "/politica-de-privacidade",
        component: PrivacyPolicy,
        meta: {
            title: "Política de Privacidade - LGPD",
        },
    },

    // Redirects
    {
        path: "/loja/minha-conta/campanha-partiu-toscana-abb",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja";
        },
    },
    {
        path: "/Centrium Server",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/centrium";
        },
    },
    {
        path: "/COOLERMASTER",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/coolermaster";
        },
    },
    {
        path: "/HP SUPRIMENTOS",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/hp-suprimentos";
        },
    },
    {
        path: "/K2 Systems",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/k2-systems";
        },
    },
    {
        path: "/LITE ON",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/lite-on";
        },
    },
    {
        path: "/Q CELLS",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/q-cells";
        },
    },
    {
        path: "/VICTRON ENERGY",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/victron-energy";
        },
    },
    {
        path: "/aldo-solar-365",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/aldo-solar-365";
        },
    },
    {
        path: "/simuladorsolar",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/calculadora-solar/";
        },
    },
    {
        path: "/calculadora-solar",
        beforeEnter(to, from, next) {
            window.location = "https://calculadorasolar.aldo.com.br/";
        },
    },
    {
        path: "/financiamento-energia-solar",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar";
        },
    },
    {
        path: "/financiamento-energia-solar/banrisul.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/barisul";
        },
    },
    {
        path: "/financiamento-energia-solar/bbrasil.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/bbrasil";
        },
    },
    {
        path: "/financiamento-energia-solar/bndes-finame.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/bndes-finame";
        },
    },
    {
        path: "/financiamento-energia-solar/bradesco.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/bradesco";
        },
    },
    {
        path: "/financiamento-energia-solar/bv.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/bv";
        },
    },
    {
        path: "/financiamento-energia-solar/proger.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/proger";
        },
    },
    {
        path: "/financiamento-energia-solar/santander-pj.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/santander-pj";
        },
    },
    {
        path: "/financiamento-energia-solar/santander.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/santander";
        },
    },
    {
        path: "/financiamento-energia-solar/sicredi-pj.html",
        beforeEnter(to, from, next) {
            window.location =
                "https://www.aldo.com.br/portais/financiamento-energia-solar/sicredi-pj";
        },
    },
    {
        path: "/financiamento-bv",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/portais/financiamento-bv";
        },
    },
    {
        path: "/Portais/Conquistas/LicenciamentoGln/SaibaMais",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/conquistas/licenciamento-gln";
        },
    },
    {
        path: "/Institucional/FaleConosco/",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/institucional/faleconosco";
        },
    },
    {
        path: "/seja-revendedor-aldo/",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja";
        },
    },
    {
        path: "/ABB",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/abb";
        },
    },
    {
        path: "/energymonitor",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja";
        },
    },
    {
        path: "/lucroreal",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja";
        },
    },
    {
        path: "/ACER",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/acer";
        },
    },
    {
        path: "/ADATA",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/adata";
        },
    },
    {
        path: "/aldosolar",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/aldo-solar";
        },
    },
    {
        path: "/AOC",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/aoc";
        },
    },
    {
        path: "/APC",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/apc";
        },
    },
    {
        path: "/ASUSTOR",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/asustor";
        },
    },
    {
        path: "/BELKIN",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/belkin";
        },
    },
    {
        path: "/BYD",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/byd";
        },
    },
    {
        path: "/CANADIAN",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/canadian";
        },
    },
    {
        path: "/CENTRIUM",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/centrium";
        },
    },
    {
        path: "/COOLERMASTER",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/collermaster";
        },
    },
    {
        path: "/CORSAIR",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/corsair";
        },
    },
    {
        path: "/DJI",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/dji";
        },
    },
    {
        path: "/FRONIUS",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/fronius";
        },
    },
    {
        path: "/galax",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/galax";
        },
    },
    {
        path: "/GENIUS",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/genius";
        },
    },
    {
        path: "/GIGABYTE",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/gigabyte";
        },
    },
    {
        path: "/HP",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/hp";
        },
    },
    {
        path: "/HyperX",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/hyperx";
        },
    },
    {
        path: "/INTEL",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/intel";
        },
    },
    {
        path: "/INTELBRAS",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/intelbras";
        },
    },
    {
        path: "/K-MEX",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/k-mex";
        },
    },
    {
        path: "/KabyLake",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/kabylake";
        },
    },
    {
        path: "/KINGSTON",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/kingston";
        },
    },
    {
        path: "/lenovo",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/lenovo";
        },
    },
    {
        path: "/MSI",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/msi";
        },
    },
    {
        path: "/Nexans",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/nexans";
        },
    },
    {
        path: "/NVIDIA",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/nvidia";
        },
    },
    {
        path: "/PHILIPS",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/philips";
        },
    },
    {
        path: "/PNY",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/pny";
        },
    },
    {
        path: "/POSITIVO",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/positivo";
        },
    },
    {
        path: "/REFUSOL",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/refusol";
        },
    },
    {
        path: "/ROMAGNOLE",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/romagnole";
        },
    },
    {
        path: "/SEAGATE",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/seagate";
        },
    },
    {
        path: "/SMA",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/sma";
        },
    },
    {
        path: "/SMS",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/sms";
        },
    },
    {
        path: "/STAUBLI",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/staubli";
        },
    },
    {
        path: "/SUPERMICRO",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/supermicro";
        },
    },
    {
        path: "/THESAN",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/thesan";
        },
    },
    {
        path: "/ultracompactpc",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/ultracompactpc";
        },
    },
    {
        path: "/ULTRATOP",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/ultratop-liva-ze";
        },
    },
    {
        path: "/ultratop-liva-ze",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/ultratop-liva-ze";
        },
    },
    {
        path: "/VAIO",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/vaio";
        },
    },
    {
        path: "/YINGLI",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/yingli";
        },
    },
    {
        path: "/Menu/Categorias/",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja";
        },
    },
    {
        path: "/crazy-off",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/campanhas/crazy-off";
        },
    },
    {
        path: "/ALDO SOLAR",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/aldo-solar";
        },
    },
    {
        path: "/VendasPortalSolar",
        beforeEnter(to, from, next) {
            window.location = "http://portalvendas.aldo.com.br/VendasPortalSolar";
        },
    },
    {
        path: "/Microsoft",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/microsoft";
        },
    },
    {
        path: "/MULTILASER",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/multilaser";
        },
    },
    {
        path: "/Menu/Marcas",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas";
        },
    },
    {
        path: "/BATERIAS MOURA",
        beforeEnter(to, from, next) {
            window.location = "https://www.aldo.com.br/loja/marcas/baterias-moura";
        },
    },
    {
        path: "/pagamento-do-pedido/:codigoLink",
        component: OrderPayment,
        name: "pagamento-do-pedido",
        meta: {
            title: "Pagamento do Pedido",
        },
    },
    // Caso não seja nenhuma das opções acima, mostra erro 404
    {
        path: "*",
        component: NotFound,
        meta: {
            title: "404 Página não encontrada",
            metaTags: [
                {
                    name: "robots",
                    content: "noindex,nofollow",
                },
            ],
        },
    },
];

const router = new VueRouter({
    routes,
    mode: "history",
});

// This callback runs before every route change, including on page load.
router.beforeEach((to, from, next) => {
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched
        .slice()
        .reverse()
        .find((r) => r.meta && r.meta.title);

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched
        .slice()
        .reverse()
        .find((r) => r.meta && r.meta.metaTags);
    // const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    document.title = ''
    if (nearestWithTitle && nearestWithTitle.meta) document.title = nearestWithTitle.meta.title;

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(
        (el) => el.parentNode.removeChild(el)
    );

    // Skip rendering meta tags if there are none.
    if (!nearestWithMeta) return next();

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags
        .map((tagDef) => {
            const tag = document.createElement("meta");

            Object.keys(tagDef).forEach((key) => {
                tag.setAttribute(key, tagDef[key]);
            });

            // We use this to track which meta tags we create, so we don't interfere with other ones.
            tag.setAttribute("data-vue-router-controlled", "");

            return tag;
        })
        // Add the meta tags to the document head.
        .forEach((tag) => document.head.appendChild(tag));

    next();
});

Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount("#app");
